import axiosInstance from '../axios/axiosInstance';
import { CommonInfoStat, ExamPracticeDoneStat, QnaTicketCountStat, Subject, UserRegisterStat } from '../model/response';

export const getCommonInfoStat = async () => {
  const { data } = await axiosInstance.get<CommonInfoStat>('/statistics/common-info');
  return data;
};

export const getStatisticUserRegister = async(statsiticType:string) => {
  const { data } = await axiosInstance.get<UserRegisterStat[]>(`/statistics/register?typeStatsitic=${statsiticType}`);
  return data;
}

export const getStatQnaTicketCount = async () => {
  const { data } = await axiosInstance.get<QnaTicketCountStat[]>('/statistics/qna-ticket-count');
  return data;
};

export const getStatisticUserAction = async(statsiticType:string) => {
  const { data } = await axiosInstance.get<UserRegisterStat[]>(`/statistics/user-action?typeStatsitic=${statsiticType}`);
  return data;
}

export const getStatExamPracticeDone = async () => {
  const { data } = await axiosInstance.get<ExamPracticeDoneStat[]>('/statistics/exam-practice-done');
  return data;
};